module.exports = __webpack_public_path__ + "img/icon_fp_phone.1e22be52.svg";